import { JobBoardsSupportedParametersComponent } from "./job-boards-supported-parameters.component";
import { JobBoardsSearchHistoryModule } from "./jobBoardsSearchHistory/job-boards-search-history.module";
export var JobBoardsSupportedParametersModule = angular
    .module('jobBoardsSupportedParameters', [JobBoardsSearchHistoryModule])
    .component(JobBoardsSupportedParametersComponent.selector, JobBoardsSupportedParametersComponent.component)
    .name;
//# sourceMappingURL=job-boards-supported-parameters.module.js.map